import React, { useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';

import './UniprotPdbLinks.scss';

function UniprotPdbLinks({ links, heading, headingClass, useShowMore, trackingAction, proteinType, useSemicolon, trackingAttrs }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const truncateAfter = 10;

  const getTrackingAttrs = useCallback(
    () => ({
      ...trackingAttrs,
      'data-tracking-type': 'linkout',
      'data-tracking-action': trackingAction,
    }),
    [trackingAttrs, trackingAction]
  );

  const linksArr = useMemo(() => map(links, (value, key) => ({ key, value })), [links]);

  const more = Math.max(0, linksArr.length - truncateAfter);
  const items = useShowMore ? (isExpanded ? linksArr : linksArr.slice(0, linksArr.length - more)) : linksArr;

  const externalIdsWrapperClass = proteinType === 'single' ? 'target-external-ids-wrapper' : '';

  return (
    <>
      <span className={`target-external-title u-els-color-n6 ${headingClass}`}>{heading}:&nbsp;</span>
      <span className={externalIdsWrapperClass}>
        {map(items, (item, i) => (
          <a
            key={i}
            className="target-external-ids no-animate u-els-color-link-inline u-els-margin-right-1o4 u-els-display-inline-block"
            href={item.value}
            target="_blank"
            {...getTrackingAttrs()}>
            {item.key}
            {(i < items.length - 1 || (more > 0 && !isExpanded)) && null}
            {items.length - 1 === i && useSemicolon && <span>;</span>}
          </a>
        ))}
      </span>

      {useShowMore && (
        <>
          {more > 0 && !isExpanded && (
            <span role="button" tabIndex="0" className="target-external-ids no-animate" onClick={() => setIsExpanded(true)}>
              + {more} more
            </span>
          )}
          {isExpanded && (
            <span role="button" tabIndex="0" className="target-external-ids no-animate" onClick={() => setIsExpanded(false)}>
              - show less
            </span>
          )}
        </>
      )}
    </>
  );
}

UniprotPdbLinks.propTypes = {
  links: PropTypes.object.isRequired,
  heading: PropTypes.string.isRequired,
  headingClass: PropTypes.string.isRequired,
  useShowMore: PropTypes.bool.isRequired,
  trackingAction: PropTypes.string.isRequired,
  proteinType: PropTypes.string.isRequired,
  useSemicolon: PropTypes.bool.isRequired,
  trackingAttrs: PropTypes.object.isRequired,
};

export default UniprotPdbLinks;
